import React, { useState } from "react";
import { Container, Row, Col, Button, Card, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ArrowRight, Envelope, Bullseye, Trophy, Phone, People, Clock, StarFill, Book, CameraVideo, Facebook, Instagram, Linkedin, Twitter, ChevronDown, ChevronUp } from "react-bootstrap-icons";
import SEOHead from "../components/SEOHead";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import img1 from "../assets/reading.png";
import brain from "../assets/brain.png";
import diploma from "../assets/diploma.png";
import flask from "../assets/flask.png";
import calc from "../assets/calculator.png";
import cubegonLogo from "../assets/cubegon-logo.png";
import whiteLogo from "../assets/whitebglogo.png";
import androidQrCode from "../assets/playstoreqr.png";
import iosQrCode from "../assets/iosqrcode.png";

const FAQItem = ({ question, answer, isOpen, onToggle }) => (
  <div className="faq-item">
    <button 
      className="faq-question" 
      onClick={onToggle}
      aria-expanded={isOpen}
    >
      <span className="faq-question-text">{question}</span>
      <span className="faq-icon">
        {isOpen ? <ChevronUp /> : <ChevronDown />}
      </span>
    </button>
    <Collapse in={isOpen}>
      <div className="faq-answer">
        <p>{answer}</p>
      </div>
    </Collapse>
  </div>
);

const Home = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const faqData = [
    {
      question: "What is CBSE Resources?",
      answer: "CBSE Resources is a curated platform that aggregates the best CBSE study materials from top educational websites, coaching institutes, and expert educators across India. We don't create content - we organize and present it for easy discovery."
    },
    {
      question: "Are the resources free to access?",
      answer: "Our platform is completely free! We provide direct links to resources from various websites. Some external resources may have their own pricing, but our curation and organization service is always free."
    },
    {
      question: "How do you select the resources?",
      answer: "We carefully curate resources based on quality, relevance, and student feedback. We prioritize content from established educational platforms, renowned educators, and trusted coaching institutes."
    },
    {
      question: "Do you own the content?",
      answer: "No, we don't own or create the content. We act as a discovery platform that organizes and presents resources from various educational websites. All content remains the property of their original creators."
    },
    {
      question: "How often is the content updated?",
      answer: "We regularly update our curated lists to include new resources, remove outdated links, and add fresh content from emerging educational platforms. Our team continuously monitors and updates the resource database."
    },
    {
      question: "Can I suggest new resources?",
      answer: "Absolutely! We welcome suggestions for new resources. If you find quality CBSE content that should be included, please contact us and we'll review it for potential addition to our curated collection."
    }
  ];
  return (
    <div className="modern-homepage">
      <SEOHead
        title="CBSE Resources - Free Study Materials for Classes 9-12 | Cubegon"
        description="Access comprehensive CBSE study materials for classes 9-12. Get free notes, video lectures, question banks, and exam preparation resources. Trusted by 50,000+ students."
        keywords="CBSE resources, CBSE study materials, CBSE notes, CBSE video lectures, CBSE question bank, CBSE exam preparation, class 9 CBSE, class 10 CBSE, class 11 CBSE, class 12 CBSE, free CBSE resources, CBSE syllabus, NCERT solutions"
        canonical="/"
        ogType="website"
      />
      <Container fluid className="px-4 px-lg-5">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-background"></div>
          <Row className="align-items-center min-vh-75 mt-4">
            <Col lg={6} className="mb-5 mb-lg-0">
              <div className="hero-content">
                <div className="hero-badge">
                  <span className="badge-text">Trusted by 50,000+ Students</span>
                </div>
                <h1 className="hero-title">
                  Your Ultimate CBSE Resource Finder
                </h1>
                <p className="hero-subtitle">
                  Discover the Best CBSE Content from Top Websites
                </p>
                <p className="hero-description">
                  Find all CBSE resources in one place! We curate and organize the best notes, video lectures, and study materials 
                  from top educational websites, coaching institutes, and expert educators across India.
                </p>
                <div className="hero-features">
                  <div className="feature-item">
                    <div className="feature-icon">✓</div>
                    <span>Curated Content</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">✓</div>
                    <span>Multiple Sources</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">✓</div>
                    <span>Quality Verified</span>
                  </div>
                </div>
                <div className="hero-actions">
                  <Button 
                    className="hero-btn-primary"
                    onClick={() => document.getElementById('classes-section').scrollIntoView({ behavior: 'smooth' })}
                  >
                    Get Started Free
                    <ArrowRight className="ms-2" />
                  </Button>
                  <Button 
                    variant="outline-secondary" 
                    className="hero-btn-secondary"
                    onClick={() => window.open('https://cubegon.app', '_blank')}
                  >
                    Get Rewards
                  </Button>
                </div>
              </div>
            </Col>
            <Col lg={6} className="text-center">
              <div className="hero-image-container">
                <div className="hero-image-wrapper">
                  <img src={img1} alt="Student studying" className="hero-image" />
                  
                </div>
              </div>
            </Col>
          </Row>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <Container>
            <Row className="g-4">
              <Col md={3} className="text-center">
                <div className="stat-item">
                  <div className="stat-number">50K+</div>
                  <div className="stat-label">Students</div>
                </div>
              </Col>
              <Col md={3} className="text-center">
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Resources</div>
                </div>
              </Col>
              <Col md={3} className="text-center">
                <div className="stat-item">
                  <div className="stat-number">95%</div>
                  <div className="stat-label">Success Rate</div>
                </div>
              </Col>
              <Col md={3} className="text-center">
                <div className="stat-item">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Support</div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Classes Section */}
        <section id="classes-section" className="classes-section">
          <div className="section-header">
            <h2 className="section-title">Choose Your Class</h2>
            <p className="section-subtitle">Select your grade to access tailored resources</p>
          </div>
          <Row className="g-4">
            {[
              { img: brain, title: "Class 9", link: "/class/9", subjects: "Math, Science, English" },
              { img: flask, title: "Class 10", link: "/class/10", subjects: "All Subjects" },
              { img: calc, title: "Class 11", link: "/class/11", subjects: "Commerce, Science" },
              { img: diploma, title: "Class 12", link: "/class/12", subjects: "Board Preparation" }
            ].map((item, index) => (
              <Col md={6} lg={3} key={index}>
                <Link to={item.link} className="text-decoration-none">
                  <Card className="class-card h-100">
                    <Card.Body className="text-center">
                      <div className="class-icon">
                        <img src={item.img} alt={item.title} className="img-fluid" />
                      </div>
                      <h5 className="class-title">{item.title}</h5>
                      <p className="class-subjects">{item.subjects}</p>
                      <div className="class-action">
                        <span>Explore Resources</span>
                        <ArrowRight className="ms-2" />
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </section>

        {/* Cubegon Branding Section */}
        <section className="cubegon-section">
          <Container>
            <div className="section-header">
              <div className="cubegon-logo mb-3">
                <img src={cubegonLogo} alt="Cubegon Logo" className="img-fluid" style={{maxHeight: '60px'}} />
              </div>
              <h2 className="section-title">Powered by Cubegon</h2>
              <p className="section-subtitle">Learn smarter, earn rewards, and level up your studies</p>
            </div>
            <Row className="g-4">
              <Col md={4}>
                <Card className="cubegon-card h-100">
                  <Card.Body className="text-center">
                    <div className="card-icon">
                      <CameraVideo />
                    </div>
                    <h5 className="card-title">AI-Powered Learning</h5>
                    <p className="card-description">
                      Get instant help with AI assistant, personalized explanations, and smart revision tips.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="cubegon-card h-100">
                  <Card.Body className="text-center">
                    <div className="card-icon">
                      <Trophy />
                    </div>
                    <h5 className="card-title">Gamified Rewards</h5>
                    <p className="card-description">
                      Earn points and coins for studying, compete on leaderboards, and redeem exciting prizes.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="cubegon-card h-100">
                  <Card.Body className="text-center">
                    <div className="card-icon">
                      <Book />
                    </div>
                    <h5 className="card-title">Premium Content</h5>
                    <p className="card-description">
                      Access 120+ video lectures, 70+ comprehensive notes, and unlimited practice tests.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <div className="text-center mt-4">
              <Button 
                className="cubegon-button"
                onClick={() => window.open('https://cubegon.app', '_blank')}
              >
                Visit Cubegon
                <ArrowRight className="ms-2" />
              </Button>
            </div>
          </Container>
        </section>

        {/* How It Works Section */}
        <section className="how-it-works-section">
          <Container>
            <div className="section-header">
              <h2 className="section-title">How CBSE Resources Works</h2>
              <p className="section-subtitle">Your one-stop platform for discovering the best CBSE content from top educational websites</p>
            </div>
            <Row className="g-4">
              <Col md={4}>
                <div className="step-card">
                  <div className="step-number">1</div>
                  <h4>Browse by Class & Subject</h4>
                  <p>Select your class (9-12) and subject to find curated resources from the best educational websites and platforms across India.</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="step-card">
                  <div className="step-number">2</div>
                  <h4>Discover Quality Content</h4>
                  <p>Access handpicked notes, video lectures, and practice materials from top educators, coaching institutes, and educational platforms.</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="step-card">
                  <div className="step-number">3</div>
                  <h4>Learn from Multiple Sources</h4>
                  <p>Compare different teaching styles and approaches by accessing content from various trusted sources, all in one place.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* CBSE Syllabus Coverage Section */}
        <section className="syllabus-section">
          <Container>
            <div className="section-header">
              <h2 className="section-title">Complete CBSE Syllabus Coverage</h2>
              <p className="section-subtitle">Access curated resources from top websites for all CBSE subjects and topics</p>
            </div>
            <Row className="g-4">
              <Col md={6}>
                <div className="syllabus-card">
                  <h3>Class 9 & 10 Foundation</h3>
                  <p>Discover the best resources from top educational websites for Mathematics, Science (Physics, Chemistry, Biology), Social Science (History, Geography, Civics, Economics), English, and Hindi. We aggregate content from leading educators and coaching institutes to help you excel in your formative years.</p>
                  <ul>
                    <li>Mathematics: Algebra, Geometry, Trigonometry, Statistics</li>
                    <li>Science: Motion, Light, Sound, Chemical Reactions, Life Processes</li>
                    <li>Social Science: Indian History, World Geography, Democratic Politics</li>
                    <li>Languages: Literature, Grammar, Writing Skills</li>
                  </ul>
                </div>
              </Col>
              <Col md={6}>
                <div className="syllabus-card">
                  <h3>Class 11 & 12 Advanced</h3>
                  <p>Access curated resources from top educational platforms for Science, Commerce, and Arts streams. We organize content from leading coaching institutes and expert educators to help you master advanced concepts and excel in board exams.</p>
                  <ul>
                    <li>Science Stream: Physics, Chemistry, Biology, Mathematics</li>
                    <li>Commerce Stream: Accountancy, Business Studies, Economics</li>
                    <li>Arts Stream: History, Geography, Political Science, Psychology</li>
                    <li>Common Subjects: English, Hindi, Physical Education</li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* FAQ Section */}
        <section className="faq-section">
          <Container>
            <div className="section-header">
              <h2 className="section-title">Frequently Asked Questions</h2>
              <p className="section-subtitle">Everything you need to know about our CBSE resources</p>
            </div>
            <div className="faq-container">
              {faqData.map((faq, index) => (
                <FAQItem
                  key={index}
                  question={faq.question}
                  answer={faq.answer}
                  isOpen={openFAQ === index}
                  onToggle={() => toggleFAQ(index)}
                />
              ))}
            </div>
          </Container>
        </section>

        {/* Study Tips Section */}
        <section className="study-tips-section">
          <Container>
            <div className="section-header">
              <h2 className="section-title">Effective Study Tips for CBSE Students</h2>
              <p className="section-subtitle">Proven strategies to maximize your learning potential</p>
            </div>
            <Row className="g-4">
              <Col md={4}>
                <div className="tip-card">
                  <div className="tip-number">01</div>
                  <h4>Create a Study Schedule</h4>
                  <p>Plan your study time effectively by creating a realistic schedule that includes breaks, revision time, and practice sessions. Consistency is key to CBSE success.</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="tip-card">
                  <div className="tip-number">02</div>
                  <h4>Focus on NCERT Books</h4>
                  <p>NCERT textbooks are the foundation of CBSE exams. Master these books thoroughly before moving to additional reference materials. Most exam questions are directly from NCERT.</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="tip-card">
                  <div className="tip-number">03</div>
                  <h4>Practice Previous Year Papers</h4>
                  <p>Solve previous year question papers to understand the exam pattern, time management, and identify important topics. This builds confidence and improves performance.</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="tip-card">
                  <div className="tip-number">04</div>
                  <h4>Make Effective Notes</h4>
                  <p>Create concise, well-organized notes with diagrams, formulas, and key points. Use our comprehensive notes as a reference and create your own personalized study materials.</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="tip-card">
                  <div className="tip-number">05</div>
                  <h4>Regular Revision</h4>
                  <p>Revise regularly to retain information long-term. Use spaced repetition techniques and our video lectures for quick revision sessions.</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="tip-card">
                  <div className="tip-number">06</div>
                  <h4>Stay Healthy</h4>
                  <p>Maintain a balanced diet, get adequate sleep, and exercise regularly. A healthy body supports a healthy mind and improves concentration and memory.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

      </Container>

      {/* Footer */}
      <footer className="cubegon-footer">
        <div className="cubegon-footer-content">
          <div className="cubegon-footer-main">
            <div className="cubegon-footer-logo">
              <img src={whiteLogo} alt="Cubegon" />
            </div>

            <div className="cubegon-footer-download">
              <h3>Download the App</h3>
              <div className="cubegon-footer-qr-container">
                <div className="cubegon-footer-qr">
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.cubegon.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ display: 'block', textDecoration: 'none' }}
                  >
                    <img src={androidQrCode} alt="Android QR code - Download from Play Store" />
                    <p style={{ textAlign: 'center', marginTop: '8px', fontSize: '12px', color: '#fff' }}>Android</p>
                  </a>
                </div>
                <div className="cubegon-footer-qr">
                  <a 
                    href="https://apps.apple.com/in/app/cubegon-smart-learning/id6752596017" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ display: 'block', textDecoration: 'none' }}
                  >
                    <img src={iosQrCode} alt="iOS QR code - Download from App Store" />
                    <p style={{ textAlign: 'center', marginTop: '8px', fontSize: '12px', color: '#fff' }}>iOS</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="cubegon-footer-bottom">
            <div className="cubegon-footer-social">
              <a aria-label="Facebook" href="https://facebook.com/cubegon" target="_blank" rel="noopener noreferrer">
                <Facebook />
              </a>
              <a aria-label="Twitter" href="https://twitter.com/cubegon" target="_blank" rel="noopener noreferrer">
                <Twitter />
              </a>
              <a aria-label="Instagram" href="https://instagram.com/cubegon.app" target="_blank" rel="noopener noreferrer">
                <Instagram />
              </a>
              <a aria-label="LinkedIn" href="https://linkedin.com/company/cubegon" target="_blank" rel="noopener noreferrer">
                <Linkedin />
              </a>
            </div>

            <p className="cubegon-footer-text">Made in 🇮🇳 with ❤️</p>
            <p className="cubegon-footer-copyright">© {new Date().getFullYear()} Numeric Education Pvt. Ltd. All rights reserved.</p>
            <div className="cubegon-footer-links">
              <a href="https://cubegon.app/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              <a href="https://cubegon.app/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
